module.exports = __webpack_public_path__ + "img/五行管家.b47f0dbb.png";